<template>
    <div class="entrance-page">
        <section class="top-part">
            <h1 class="page-title">
                <img v-if="lang == 'cn'" src="../img/hall-cover/top-title-cn.webp" />
                <img v-else src="../img/hall-cover/top-title-en.webp" />
            </h1>
            <!-- 
                ↑ 上方标题
                ↓ 大厅列表 
            -->
            <div class="main-box">
                <ClientOnly>
                    <div class="cell" v-for="(oHall) of aHalls" :key="oHall.intOrder">
                        <HallCover :class="{}" :hallOrderNo="oHall.intOrder" @click="fnGoIntoOneHall(oHall)"
                            :info="oHall" :disabled="!oHall.accessable || !oHall.enabled" />
                    </div>
                </ClientOnly>
            </div>
        </section>
        <!-- 
            ↑ 大厅列表 
            ↓ 下方按钮 
        -->
        <footer class="footer-bar">
            <ButtonThe3DButton class="" @click="goIntoRandomly()" size="lg" color="red">
                {{ $t('redPacketMines.quickJoin') }}
            </ButtonThe3DButton>
        </footer>
    </div>
    <!--
        ↓ 历史“详情” 窗口，在此监听 route 参数变化并打开
        ↓ 主要服务于从管理员的后台界面进入的情况，后面管理员界面的数据没有厅 id，所以跳到入口页打开游戏历史 
    -->
    <CasinoHistoryModalGameDetali :gameDropValue="'goldenFlower'" />
    <NoticeDialog v-model="show" :displayTitle="$t('Note')" :main-text="$t(text)"
        :displaySubText="$t(displaySubText)"
        :displayButtonText="$t('commonInfo.confirm')" @confirm="show = false" />
</template>


<script lang="ts">
import HallCover from '../_components/hallCover.vue';
import { toCloseLoading } from '@/layouts/gameCoat/ts/gameCoat';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { getHallsList } from '~/pages/casino/zhajinhuaGame/ts/goldenFlowerCommon';
import { useGameSocket } from '@/socket/game';
import { waitUnmount } from '@/utils/requestGuard';

export default defineComponent({
    name: 'goldenflowerGameEntrance',
    components: {
        HallCover,
    },
    data() {
        return {
            joinStateStore: useJoinStateStore(),
            show: false,
            text: 'goldenFlower.lowBalance',
            displaySubText: 'niuniu.rechargePrompt',
            _isGoingIndoor: false,
            _isUnmounting: false,
        };
    },
    computed: {
        aHalls() {
            if (import.meta.server) return [];
            const aList01 = getHallsList();
            const aOrder = [ // ← 各厅的 DOM顺序 
                1, 5,
                2,
                3, 4,
            ];
            const aResult = aOrder.flatMap(iNumber => {
                const oTarget = aList01.find((oThis, idx) => {
                    return oThis.intOrder == iNumber;
                });
                if (oTarget) return oTarget;
                return [];
            });
            return aResult;
        },
        lang() {
            const $i18n = useNuxtApp().$i18n;
            return $i18n.locale.value;
        },
    },
    created() {

    },
    async mounted() {
        toCloseLoading();
        // ↓ 等待游戏页 onBeforeUnmount 执行完毕
        await waitUnmount();
        // ↓ 如果等待期间组件已开始卸载（快速回退场景），跳过后续操作
        if (this._isUnmounting) return;
        // ↓ 进入大厅时调用 join 接口，参数传空
        const { EMIT_GAME_JOIN } = useGameSocket();
        EMIT_GAME_JOIN('zhajinhua', {}, (res) => {
            console.log('zhajinhua entrance join:', res);
        });
    },
    beforeUnmount() {
        this._isUnmounting = true;
        // ↓ 离开大厅时调用 exit 接口，通知服务器用户已离开游戏
        const { EMIT_GAME_EXIT } = useGameSocket();
        EMIT_GAME_EXIT('zhajinhua');
    },
    methods: {
        fnGoIntoOneHall(oOneHall) {
            if (!oOneHall.enabled) {
                this.show = true;
                this.text = 'goldenFlower.hallDisabled';
                this.displaySubText = 'game.chageHall';
                return;
            }
            if (oOneHall['accessable'] == false) {
                this.show = true;
                this.text = 'goldenFlower.lowBalance';
                this.displaySubText = 'niuniu.rechargePrompt'
                return;
            }
            const path = `/casino/zhajinhuaGame/indoor/${oOneHall.intOrder}`;
            this._isGoingIndoor = true;
            useRouter().push({
                path: getLocalPath(path),
                query: {
                    name: oOneHall.name,
                    src: 'entrance',
                },
            });
        },
        goIntoRandomly() {
            // 按余额找出有权限的厅，然后随机进入 
            const oHall = this.aHalls.filter((cur, idx) => {
                return cur.accessable;
            }).find((cur, idx, arr) => {
                // console.log('arr', arr); 
                const bResult = (
                    (Math.random() > 0.5)
                    || (idx === arr.length - 1)
                );
                return bResult;
            });
            if (!oHall) {
                this.show = true;
                this.text = 'goldenFlower.lowBalance';
                return;
            }
            this.fnGoIntoOneHall(oHall);
        },
    },
});

</script>


<style scoped lang="scss">
.entrance-page {
    max-width: 500px;
    margin: 0 auto;
    height: calc(100vh - var(--header-heigh));
    max-height: calc(100vh - var(--header-heigh));
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    background-image: url(../img/bg-entrance.webp);
    background-size: cover;
    background-position: center;
    overflow-y: auto;
    --padding-x: 18px;
}

.top-part {
    padding: 8px var(--padding-x) 60px;
    width: 100%;
    margin: 0 auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    .page-title {
        opacity: 1;
        margin: 20px 0;
    }
}

.main-box {
    width: 100%;
    margin: 0 auto;
    padding: 3px 0 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 20px;
    column-gap: 10px;
    flex: 1;
    .cell {
        // max-height: calc(100vh / 5); 
        &:nth-child(1),
        &:nth-child(3),
        &:nth-child(4) {
            .hall-cover {
                margin-left: auto;
            }
        }

        &:nth-child(2) {
            grid-column-start: 2;
            grid-row-end: 3;
            grid-row-start: 1;
        }

        .hall-cover {
            display: flex;
            height: 100%;
            // width: 150px; 
        }
    }
}


@media screen and (max-width: 400px) {
    // .main-box{
    //     row-gap: 15px;
    //     column-gap: 30px;
    // }
    // .cell{
    //     .hall-cover{
    //         width: 120px;
    //     }
    // }
}

@media screen and (max-width: 360px) {
    // .main-box{
    //     row-gap: 10px;
    //     column-gap: 25px;
    // }
    // .cell{
    //     .hall-cover{
    //         width: 110px;
    //     }
    // }
}

.footer-bar {
    flex: 0 0 auto;
    width: 100%;
    margin-bottom: 30px;
    .button-3d {
        display: block;
        margin: 0 auto;
        width: calc(100% - 50px);
    }
}
</style>
